import axios from 'axios';
import { noop, isEmpty, startsWith } from 'lodash';

import { isUrl } from 'utils/validate';

export const getFilenameFromUrl = url => {
  if (!isUrl(url)) {
    return '';
  }
  const path =
    url &&
    new URL(url, startsWith(url, '/') ? window.location.origin : undefined)
      .pathname;

  return path && path.split('/').pop();
};

export const downloadFile = async (
  downloadUrl,
  onDownload = noop,
  onError = noop,
) => {
  const link = document.createElement('a');
  link.setAttribute('target', '_blank');
  link.href = downloadUrl;
  try {
    const response = await axios({
      method: 'get',
      url: downloadUrl,
      responseType: 'blob',
    });
    if (response?.status === 200) {
      onDownload();
      const url = window.URL.createObjectURL(new Blob([response.data]));
      link.href = url;

      let fileName = getFilenameFromUrl(downloadUrl);
      if (response.headers['content-disposition']) {
        // eslint-disable-next-line prefer-destructuring
        fileName =
          response.headers['content-disposition'].split('filename=')[1];
      }
      link.setAttribute('download', fileName);
    }
  } catch (e) {
    onError();
    console.warn('Failed to download file with url', e);
  }
  link.click();
};

export const addQueryParams = (url, params) => {
  if (isEmpty(params)) {
    return url;
  }

  const queryString = Object.entries(params)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${queryString}`;
};
